import type { ReactNode } from "react";
import { C } from "../tokens";

type Color = "blue" | "green" | "amber" | "red" | "purple" | "cyan" | "muted";

const map: Record<Color, { bg: string; color: string; border: string }> = {
  blue:   { bg: C.blueDim,   color: C.blue,   border: "rgba(45,127,249,0.3)" },
  green:  { bg: C.greenDim,  color: C.green,  border: "rgba(16,185,129,0.3)" },
  amber:  { bg: C.amberDim,  color: C.amber,  border: "rgba(245,158,11,0.3)" },
  red:    { bg: C.redDim,    color: C.red,    border: "rgba(239,68,68,0.3)" },
  purple: { bg: C.purpleDim, color: C.purple, border: "rgba(139,92,246,0.3)" },
  cyan:   { bg: C.cyanDim,   color: C.cyan,   border: "rgba(6,182,212,0.3)" },
  muted:  { bg: "rgba(90,115,153,0.15)", color: C.textSub, border: "rgba(90,115,153,0.3)" },
};

export function Badge({
  children, color = "blue", className,
}: { children: ReactNode; color?: Color; className?: string }) {
  const s = map[color];
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "1px 6px",
        borderRadius: 6,
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: 0.3,
        textTransform: "uppercase",
        background: s.bg,
        color: s.color,
        border: `1px solid ${s.border}`,
      }}
    >
      {children}
    </span>
  );
}
